import React, { useState, useEffect, useCallback } from "react";

import "./customslider.css";

function CustomCarousel({ children }) {
  const childItems = React.Children.toArray(children);
  const totalSlides = childItems.length;
  const [activeIndex, setActiveIndex] = useState(0);
  const [slideDone, setSlideDone] = useState(true);
  const [timeID, setTimeID] = useState(null);

  const slideNext = useCallback(() => {
    setActiveIndex((val) => {
      if (val >= totalSlides - 1) {
        return 0;
      } else {
        return val + 1;
      }
    });
  }, [totalSlides]);

  const slidePrev = () => {
    setActiveIndex((val) => {
      if (val <= 0) {
        return totalSlides - 1;
      } else {
        return val - 1;
      }
    });
  };

  useEffect(() => {
    if (activeIndex >= totalSlides) {
      setActiveIndex(0);
    }
  }, [activeIndex, totalSlides]);

  useEffect(() => {
    if (totalSlides <= 1) {
      return undefined;
    }

    if (slideDone) {
      setSlideDone(false);
      const timerId = setTimeout(() => {
        slideNext();
        setSlideDone(true);
      }, 5000);

      setTimeID(timerId);

      return () => clearTimeout(timerId);
    }

    return undefined;
  }, [slideDone, slideNext, totalSlides]);

  const AutoPlayStop = () => {
    if (timeID > 0) {
      clearTimeout(timeID);
      setSlideDone(false);
    }
  };

  const AutoPlayStart = () => {
    if (!slideDone) {
      setSlideDone(true);
    }
  };

  if (totalSlides === 0) {
    return null;
  }

  return (
    <div
      className="container__slider"
      onMouseEnter={AutoPlayStop}
      onMouseLeave={AutoPlayStart}
    >
      {childItems.map((item, index) => {
        return (
          <div
            className={"slider__item slider__item-active-" + (activeIndex + 1)}
            key={index}
          >
            {item}
          </div>
        );
      })}

      {totalSlides > 1 && (
        <div className="container__slider__links">
          {childItems.map((item, index) => {
            return (
              <button
                key={index}
                className={
                  activeIndex === index
                    ? "container__slider__links-small container__slider__links-small-active"
                    : "container__slider__links-small"
                }
                onClick={(e) => {
                  e.preventDefault();
                  setActiveIndex(index);
                }}
              ></button>
            );
          })}
        </div>
      )}

      {totalSlides > 1 && (
        <>
          <button
            className="slider__btn-next"
            onClick={(e) => {
              e.preventDefault();
              slideNext();
            }}
          />
          <button
            className="slider__btn-prev"
            onClick={(e) => {
              e.preventDefault();
              slidePrev();
            }}
          />
        </>
      )}
    </div>
  );
}

export default CustomCarousel;
